import React, { useState } from 'react';
import './portfolio.css';
import IMG1 from '../../assets/chat_app.jpeg';
import IMG2 from '../../assets/project-1.jpg';
import IMG3 from '../../assets/sakilla.PNG';
import IMG5 from '../../assets/ai_enabled_b2b_system.png';
import IMG6 from '../../assets/CADisease_Pred.PNG';
import IMG4 from '../../assets/CHD_pred.PNG';
import { MdReadMore } from 'react-icons/md';

const data = [
  {
    id: 1,
    image: IMG4,
    title: "Ensembling in Prediction Model for CHD",
    tags: ["AIML"],
    github: 'https://github.com/Milan-Sharma-449/IACADEC',
    demo: 'https://github.com/Milan-Sharma-449/IACADEC'
  },
  {
    id: 2,
    image: IMG6,
    title: "CAD Prediction using ML",
    tags: ["AIML"],
    github: 'https://github.com/Milan-Sharma-449/Coronary-Artery-Disease-Prediction-using-ML',
    demo: 'https://github.com/Milan-Sharma-449/Coronary-Artery-Disease-Prediction-using-ML'
  },
  {
    id: 3,
    image: IMG1,
    title: "Sinit Chat - Chat App",
    tags: ["React"],
    github: 'https://github.com/Milan-Sharma-449/chat-app',
    demo: 'https://chat-web-app-d4c52.web.app/'
  },
  {
    id: 4,
    image: IMG2,
    title: "Box-Office",
    tags: ["React"],
    github: 'https://github.com/Milan-Sharma-449/box-office',
    demo: 'https://milansharma.site/boxoffice'
  },
  {
    id: 5,
    image: IMG5,
    title: "FinTeach AI B2B Management System - Internship",
    tags: ["Full Stack"],
    github: 'https://github.com/Milan-Sharma-449/internship',
    demo: 'https://github.com/Milan-Sharma-449/internship'
  },
  {
    id: 6,
    image: IMG3,
    title: "Sakilla Project - Internship",
    tags: ["Java"],
    github: 'https://github.com/Milan-Sharma-449/Hrc-Training-Sakila-',
    demo: 'https://github.com/Milan-Sharma-449/Hrc-Training-Sakila-'
  }
];

const categories = ["All", "React", "Java", "AIML", "Full Stack"];

const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredData = selectedCategory === "All"
    ? data
    : data.filter(item => item.tags.includes(selectedCategory));

  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      {/* Navbar-style category filter */}
      <div className="portfolio__navbar">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`portfolio__nav-button ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Portfolio Items */}
      <div className='container portfolio__container'>
        {filteredData.map(({ id, image, title, github, demo }) => (
          <article key={id} className='portfolio__item'>
            <div className='portfolio__item-image'>
              <img src={image} alt={title} />
            </div>
            <h3>{title}</h3>
            <div className='portfolio__item-cta'>
              <a href={github} className='btn' target='_blank' rel="noreferrer">Github</a>
              <a href={demo} className='btn btn-primary' target='_blank' rel="noreferrer">LiveDemo</a>
            </div>
          </article>
        ))}
      </div>

      <div className='projects'>
        <h2>Want to see more</h2>
        <a href='https://milansharma.in/projects' className='read__more'><MdReadMore /></a>
      </div>
    </section>
  );
};

export default Portfolio;